// extracted by mini-css-extract-plugin
export var backdrop = "Modal-module--backdrop--WGtGS";
export var close = "Modal-module--close--0a+xS";
export var closeIcon = "Modal-module--closeIcon--KvaWm";
export var component = "Modal-module--component--xjb2h";
export var container = "Modal-module--container--zl-9k";
export var content = "Modal-module--content--zFovJ";
export var inner = "Modal-module--inner--WSbie";
export var toggle = "Modal-module--toggle--z5x-u";